import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './styles/quasar.styl'
import 'quasar/dist/quasar.ie.polyfills'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QOptionGroup,
  QForm,
  Notify,
  QCheckbox,
  Ripple
} from 'quasar'

Vue.use(Quasar, {
  config: {
    brand: {
      primary: '#ea6300',
      secondary: '#26A69A',
      accent: '#9C27B0',
      positive: '#21BA45',
      negative: '#C10015',
      info: '#31CCEC',
      warning: '#F2C037'
    }
  },
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QCheckbox,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QOptionGroup,
    QForm,
    Notify
  },
  directives: {
    Ripple
  },
  plugins: {
    Notify
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
